import { Tooltip, Avatar, Stack } from "@mui/material";
import DoubleLine from "../DoubleLine/DoubleLine";

const BMXAvatarsUserGroup = ({ workers = [] }) => {
  if (workers.length === 0) return null;

  const formatWorker = (user) => (
    <DoubleLine
      key={user.id || `${user.firstName}-${user.lastName}`}
      firstLine={`${user.firstName} ${user.lastName}`}
      secondLine={
        user.departments?.map((dep) => dep.shortName).join(", ") || ""
      }
    />
  );

  if (workers.length === 1) return formatWorker(workers[0]);

  const [first, ...rest] = workers;

  return (
    <Stack
      direction="row"
      alignItems="center"
      useFlexGap
      sx={{ flexWrap: "wrap" }}
    >
      {formatWorker(first)}
      <Tooltip title={<>{rest.map(formatWorker)}</>} arrow>
        <Avatar
          sx={{
            width: 23,
            height: 23,
            fontSize: "0.6rem",
            bgcolor: "var(--BMX-primary)",
            color: "#fff",
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          +{rest.length}
        </Avatar>
      </Tooltip>
    </Stack>
  );
};

export default BMXAvatarsUserGroup;
